export default __webpack_public_path__ + "static/media/LogoutIcon.f37e8ba7.svg";